import { useState, useEffect } from "react";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import { Grid } from "@mui/material";
import { FormularioDinamicoModelos } from "src/general_components/FormularioDinamicoModelos";
import { getTablaEstructura, getDataSelect, getPaginatedData, getDataByCondition, deleteDataById } from "src/hooks/structureTable";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@mui/material";
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import SearchFormGenerico from "src/general_components/SearchFormGenerico";
import { GenericCard } from "src/general_components/GenericCard";
import { Fab, useTheme, useMediaQuery } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

export const ABMGenerico = ({ modelo, titulo = false, icon, condiciones, columnasAexcluir, valuesDefaultForm = false, columnasAdicional = [], condiciones_select = false, joins = false, enableSearch = true }) => {
    const [createButton, setCreateButton] = useState(false);
    const [dataEdit, setDataEdit] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [columns, setColumns] = useState([]);
    const [formData, setFormData] = useState({});
    const [options, setOptions] = useState({});
    const [columnsLoaded, setColumnsLoaded] = useState(false);
    const [filtrosBase] = useState({
        modelo: modelo,
        condiciones: condiciones || [],
        joins: joins
    });
    const [searchValues, setSearchValues] = useState({});

    const [filtrosBusqueda, setFiltrosBusqueda] = useState([]);
    const [filtros, setFiltros] = useState({
        modelo: modelo,
        condiciones: condiciones || [],
        joins: joins
    });


    const [modalSearch, setModalSearch] = useState(false);
    const [childModal, setChildModal] = useState(null);
    const [modalName, setModalName] = useState("Buscar");

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const buttonBuscar = enableSearch ? () => (
        <Button
            endIcon={<SearchIcon />}
            onClick={handleOpenSearch}
            variant="contained"
            style={{
                color: '#FFFFFF',
                fontFamily: 'Roboto, sans-serif',
                minWidth: '120px',
                width: '120px',
                fontSize: '11px',
                height: '30px',
                marginLeft: 10
            }}
        >
            Buscar
        </Button>
    ) : null;

    const handleOpenSearch = () => {
        setModalName("Buscar");

        setChildModal(
            <SearchFormGenerico
                columns={columns}
                initialValues={searchValues}   // 👈 CLAVE
                onSearch={handleSearch}
                onChange={setSearchValues}     // 👈 CLAVE
                onClose={() => setModalSearch(false)}
            />
        );

        setModalSearch(true);
    };

    const handleSearch = (dataBusqueda) => {
        setFiltrosBusqueda(dataBusqueda || []);
        setModalSearch(false);
    };


    const toPascalCase = (str) => {
        return str
            .replace(/_/g, ' ')  // Reemplaza guiones bajos con espacios
            .replace(/\b\w+/g, (word) => word[0].toUpperCase() + word.slice(1).toLowerCase());  // Convierte la primera letra de cada palabra a mayúscula
    };

    // Ejemplo de uso:
    const listName = titulo || toPascalCase(modelo);

    useEffect(() => {
        const filtrarCampos = async (formDataResponse) => {
            const camposFiltrados = {};

            for (const fieldName in formDataResponse) {
                if (fieldName.includes('id_')) {
                    const palabraExtraida = fieldName.replace('id_', '');
                    const valorLocalStorage = JSON.parse(localStorage.getItem("siam-" + palabraExtraida))?.[palabraExtraida];

                    if (valorLocalStorage) {
                        const opcionesFiltradas = valorLocalStorage.map(({ id, nombre, descripcion, label, detalle }) => ({
                            id,
                            nombre: nombre || descripcion || detalle || label || 'Sin Nombre',
                        }));

                        camposFiltrados[fieldName] = {
                            ...formDataResponse[fieldName],
                            options: opcionesFiltradas,
                        };
                    } else {
                        let condiciones_where = [];

                        for (const key in condiciones_select) {
                            if (key.includes(palabraExtraida)) {
                                console.log("entreee", condiciones_select[key]);

                                condiciones_select[key].forEach(obj => {
                                    console.log("obj", obj);

                                    // Iterar sobre las propiedades del objeto
                                    for (const propiedad in obj) {
                                        condiciones_where.push({
                                            campo: propiedad,
                                            valor: obj[propiedad],
                                            operador: " = "
                                        });
                                    }
                                });
                            }
                        }

                        console.log('condiciones_where', condiciones_where);

                        const datosSelect = await getDataSelect(palabraExtraida, condiciones_where);
                        const opcionesFiltradas = datosSelect.map(({ id, nombre, descripcion, label, detalle }) => ({
                            id,
                            nombre: nombre || descripcion || detalle || label || 'Sin Nombre',
                        }));
                        console.log("opcionesFiltradas", opcionesFiltradas)
                        camposFiltrados[fieldName] = {
                            ...formDataResponse[fieldName],
                            options: opcionesFiltradas,
                        };
                    }
                }
            }

            let camposFinal = { ...formDataResponse, ...camposFiltrados };

            if (camposFinal.id) {
                delete camposFinal.id;
            }

            return camposFinal;
        };

        const getEstructuraTabla = async () => {
            let response = await getTablaEstructura(modelo);
            if (response.status === "true") {
                const formDataResponse = response.wsResponse;
                const campos = await filtrarCampos(formDataResponse);
                let camposFiltrados = campos;
                if (columnasAexcluir) {
                    camposFiltrados = Object.fromEntries(
                        Object.entries(campos).filter(([key]) => !columnasAexcluir.includes(key))
                    );
                }

                const generatedColumns = Object.keys(camposFiltrados).slice(0, 5).map((field, index) => {
                    const label = camposFiltrados[field].label;
                    const headerName = typeof label === 'object' && Object.keys(label).length === 0
                        ? field.charAt(0).toUpperCase() + field.slice(1)
                        : label || field.charAt(0).toUpperCase() + field.slice(1);

                    const column = {
                        field: field,
                        headerName: headerName,
                        flex: 1,
                        align: 'center',
                        headerAlign: "center",
                    };

                    // Check if the field is "activo" to apply custom rendering
                    if (field === 'activo') {
                        column.flex = 0.2;
                        column.renderCell = (params) => (params.value === "1" ? 'Sí' : 'No');
                    }

                    return column;
                });

                const columnasGeneradas = [{
                    field: "id",
                    headerName: "ID",
                    flex: 0.1, // Divide equitativamente entre el número de columnas
                }, ...generatedColumns, ...columnasAdicional
                ];

                setColumns(columnasGeneradas);
                if (valuesDefaultForm) {
                    // Eliminar propiedades de camposFinal si coinciden con valuesDefaultForm
                    Object.keys(valuesDefaultForm).forEach((key) => {
                        delete campos[key];
                    });
                }
                setFormData(campos);

                setColumnsLoaded(true); // Indicar que las columnas se han cargado
            }
        };

        getEstructuraTabla();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelo]);

    if (createButton === false && dataEdit.id !== undefined) {
        setDataEdit([]);
    }

    useEffect(() => {
        const condicionesFinales = [
            ...(filtrosBase.condiciones || []),
            ...(filtrosBusqueda || [])
        ];

        setFiltros({
            modelo: filtrosBase.modelo,
            joins: filtrosBase.joins,
            condiciones: condicionesFinales
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtrosBusqueda]);





    const handleDelete = async (id) => {

        // deleteDataById expects (id, params, idElementData) where idElementData has { modelo }
        // params is usually not used or is for filtering, checking structureTable.js it is just passed.
        // We need to pass an object with 'modelo' as the third argument.
        const success = await deleteDataById(id, {}, { modelo: modelo });

        if (success) {
            window.location.reload();
        }

    };

    const mobileComponent = ({ row }) => (
        <GenericCard
            row={row}
            columns={columns}
            onEdit={(item) => {
                setDataEdit(item);
                setCreateButton(true);
            }}
            onDelete={handleDelete}
        />
    );

    useEffect(() => {
        setOptions({
            cols: columns,
            get: getDataByCondition,
            getPaginated: getPaginatedData,
            pageSize: [5, 10, 25],
            edit: true,
            delete: deleteDataById,
            limit: 50,
            filter: true,
            exportData: true,
            server: true,
            createButton,
            setCreateButton,
            setDataEdit,
            idElementData: filtros,
            mobileComponent: mobileComponent,
            ...(enableSearch && {
                buttonExtraOn: true,
                ButtonExtra: buttonBuscar,
            })
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columns, filtros, enableSearch]);





    // Mobile specific FABs
    const mobileFabs = isMobile && (
        <div style={{ position: 'fixed', bottom: 56, right: 20, display: 'flex', flexDirection: 'column', gap: '10px', zIndex: 9999 }}>
            {enableSearch && (
                <Fab
                    color="secondary"
                    aria-label="search"
                    size="small"
                    onClick={handleOpenSearch}
                >
                    <SearchIcon />
                </Fab>
            )}
            <Fab
                color="primary"
                aria-label="add"
                onClick={() => {

                    setCreateButton(true);
                    setDataEdit(false);
                }}
            >
                <AddIcon />
            </Fab>
        </div>
    );

    return (
        <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
            <PageHeaderCard title={listName} icon={icon} />

            {columnsLoaded && (
                <>
                    <ListTablePaginated options={options} />
                    <FormularioDinamicoModelos
                        data={dataEdit}
                        createButton={createButton}
                        listName={listName}
                        setCreateButton={setCreateButton}
                        setOptions={setOptions}
                        options={options}
                        formData={formData}
                        modelo={modelo}
                        dataDefault={valuesDefaultForm}
                    />
                    {enableSearch && (
                        <SimpleDialogComponent
                            open={modalSearch}
                            modalName={modalName}
                            child={childModal}
                            handleClose={() => setModalSearch(false)}
                            buttonEnviar={false}
                            buttonCancelar={true}
                            maxWidth="md"
                        />
                    )}
                    {mobileFabs}
                </>
            )}
        </Grid>
    );
};
